import { type MouseEvent, type ReactNode } from 'react';
import { type TreeNode } from 'primereact/treenode';
import {
    SelectedValuePills,
    type SelectedPillEntry,
} from '../../../_utils/components';

interface TreeSelectSelectedPillsProps {
    selectedNodes: TreeNode[];
    onDismiss: (key: string, event: MouseEvent<HTMLButtonElement>) => void;
    /** When true, pills are shown read-only (no dismiss/remove control). */
    disabled?: boolean;
}

function toSelectedPillEntry(node: TreeNode): SelectedPillEntry<string> {
    const key = String(node.key);
    const label = node.label ? String(node.label) : key;

    return { id: key, label, value: key };
}

export function TreeSelectSelectedPills({
    onDismiss,
    selectedNodes,
    disabled,
}: TreeSelectSelectedPillsProps): ReactNode {
    return (
        <SelectedValuePills
            entries={selectedNodes.map(toSelectedPillEntry)}
            wrapperClassName="ics-treeselect__pills"
            pillClassName="ics-treeselect__pill"
            pillLabelClassName="ics-treeselect__pill-label"
            onDismiss={onDismiss}
            disabled={disabled}
        />
    );
}
